import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ModelCreatePage } from '@/features/ai/llm/llm-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouvel alias de modèle. */
export const Route = createFileRoute('/$tenant/llm/models/new')({ component: ModelCreateRoute });

function ModelCreateRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="llmGateway" crumbs={[{ label: t('nav.items.llmGateway') }]}>
      <ModelCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
